<template>
    <div>
        <p class="mb-3">
            <label>
                Por favor tener en cuenta que los archivos generados solo estarán
                disponibles por 2 horas
            </label>
            <b-button class="float-right" variant="primary" @click="reloadList">
                <i class="fa fa-refresh mr-1"></i>
                Actualizar información
            </b-button>
        </p>
        <b-table responsive bordered striped hover :items="bulkExportTicketsList" :fields="columnas"
            empty-text="No hay descargas masivas para mostrar" thead-tr-class="table-active" show-empty>
            <template v-slot:cell(estado_procesamiento)="data">
                <b-badge v-if="data.item.estado_procesamiento == 'PROCESANDO'" variant="warning"
                    v-text="data.item.estado_procesamiento" />
                <b-badge v-else-if="data.item.estado_procesamiento == 'TERMINADO' && !data.item.errores"
                    variant="success" v-text="data.item.estado_procesamiento" />
                <b-badge v-else-if="data.item.errores" variant="danger" v-text="'TERMINADO CON ERRORES'" />
                <b-badge v-else variant="secondary" v-text="'PENDIENTE'" />
            </template>

            <template v-slot:cell(opciones)="data">
                <b-button variant="primary" size="sm" v-if="data.item.downloadable" @click="download(data.item)"
                    v-b-tooltip.hover title="Descargar ZIP">
                    <i class="fa fa-download icon"></i>
                </b-button>
            </template>
        </b-table>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Pusher from "pusher-js";
import { getUuidToUser } from "@/plugins/acl";

export default {
    name: "tickets-descarga-masiva-listado",
    props: {
        companyId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            columnas: [
                { key: "fecha_solicitud", label: "Fecha de solicitud", sortable: true },
                { key: "fecha_generacion", label: "Fecha de generación", sortable: true },
                { key: "estado_procesamiento", label: "Estado", sortable: true },
                { key: "opciones", label: "Opciones", thClass: "text-center" },
            ],
            pusher: null,
        };
    },
    computed: {
        ...mapState("tickets", ["bulkExportTicketsList"]),
    },
    created() {
        this.reloadList();
    },
    mounted() {
        this.subscribeToNotifications();
    },
    beforeDestroy() {
        this.unsubscribeFromNotifications();
    },
    methods: {
        ...mapActions("tickets", ["listBulkExportTickets", "downloadBulkExportTickets"]),
        async reloadList() {
            await this.listBulkExportTickets(this.companyId);
        },
        async download(item) {
            await this.downloadBulkExportTickets(item);
        },
        subscribeToNotifications() {
            const uuid = getUuidToUser();
            if (!uuid) return;

            this.pusher = new Pusher("5c41c1dc4bec329b2165", {
                cluster: "us2",
            });

            const channel = this.pusher.subscribe(uuid);
            channel.bind("notificaciones", (data) => {
                if (data.mensaje && (data.mensaje.titulo.includes("Descarga masiva de tickets") || data.mensaje.titulo.includes("Error en descarga masiva de tickets"))) {
                    this.reloadList();
                }
            });
        },
        unsubscribeFromNotifications() {
            if (this.pusher) {
                const uuid = getUuidToUser();
                if (uuid) this.pusher.unsubscribe(uuid);
                this.pusher.disconnect();
            }
        },
    },
};
</script>
